import styled from "styled-components";

export const PhotosEditBody = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    padding: 16px;
    gap: 12px;
    row-gap: 16px;
`

export const PhotosEditItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    
    img {
        width: 92px;
        height: 92px;
    }
    
    h5 {
        margin-top: 4px;
        margin-bottom: 2px;

        color: var(--fg-default, rgba(16, 24, 40, 1));
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    }
    
    p {
        color: var(--fg-muted, rgba(16, 24, 40, 0.55));
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
    }
    
    &:hover {
        .photo-actions {
            display: flex;
        }
    }
`

export const PhotosEditActionsWrapper = styled.div`
    position: absolute;
    right: 8px;
    top: 8px;
    display: none;
    flex-direction: column;
    gap: 4px;
    
    > div {
        width: 24px;
        height: 24px;
        padding: 4px;
        border-radius: var(--iconbutton-s-border-radius, 8px);
        background: var(--static-white, rgba(255, 255, 255, 1));
        cursor: pointer;        
    }
`